// auth.guard.ts

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service'; // Replace with your authentication service
import { JwtService } from './jwt.service';
import * as constants from "./constant";

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: JwtService, private router: Router) {}


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('AuthGuard is checking...');

    if (this.authService.validateToken(sessionStorage.getItem(constants.LOGIN_TOKEN_KEY))) {
      console.log(sessionStorage.getItem(constants.LOGIN_TOKEN_KEY),this.authService.validateToken(null))
      console.log('User is authenticated.');
      return true;
    } else {
      console.log('User is not authenticated. Redirecting to login.');
      sessionStorage.clear()
      return this.router.parseUrl('/landing/login');
    }
  }

}
